export const environment = {
  production: true,
  version: "1.3.39",
  recaptachaSiteKey: "6Le1n8gZAAAAAIkPRD6_t8Ivkx6ql0wUlJ2JRU5T",
  errorMessage: "Oops! Something went wrong. Please try again.",
  //addresApiKey: "LQWR5Ed3bka96wTkYuJ4eA27931",
  addresApiKey:"ak_moonqgqz9MaSsq9jj69dDFrHMdlZR",
  horizontalPosition: "right",
  verticalPosition: "top",
  whatsappLink: "https%3A%2F%2Fsmileorchard.co.uk%2F",
  emailPattern: "^[A-Za-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$",
  phonePattern: "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$",
  passwordPattern: "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{7,}",
  inputTypeTextPattern: "^[a-zA-Z]*$",
  googleCDNUrl: "https://storage.googleapis.com/smileorchard/",
  clinicName:'Smile Orchard',
  primaryColor:'#929a3e',
  secondaryColor:'#7c6856',
  webToken: "0E1CECE1-9C9A-4211-942C-BAF382C509DF",

  // live 
  configUrl: "https://liveapi.smileorchard.co.uk/",// For Node Server
  websiteUrl: "https://smileorchard.co.uk/", // For smileorchard Website
  routeLinkBlogs: 'https://soblogapi.smileorchard.co.uk/',
  configSocketUrlStaff: "https://chatapi.smileorchard.co.uk/", // For smileorchard Chat Node Server
  PayPalUrl:"AUK3N9x8Z5iIKAn1R0GnZiDsgGtuaQsHYxFdXmnxmHZybaDneU2zr4anQ5yOx8gRQjxAQ71C03NjEYGj",
  env: "production",
  mode: "live",
  
};
